import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Cookies from "js-cookie";

import Login from "@/views/Auth/Login.vue";

import Dashboard from "@/views/Dashboard.vue";
import Settings from "@/views/Account/Settings";

import ProjectIndex from "@/views/Projects/Index";
import ProjectShow from "@/views/Projects/Show";
import TeamIndex from "@/views/Team/Index";
import ClipIndex from "@/views/Clips/Index";
import VideoIndex from "@/views/Videos/Index";
import VideoShow from "@/views/Videos/Show";
import CalendarIndex from "@/views/Calendar/Index";
import ReportsIndex from "@/views/Reports/Index";
import DocumentsIndex from "@/views/Documents/Index";

import { checkGuard } from "@/helpers/router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/projects",
        name: "projects",
        component: ProjectIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/projects/:id",
        name: "project-show",
        component: ProjectShow,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/team",
        name: "team",
        component: TeamIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/clips",
        name: "clips",
        component: ClipIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/videos",
        name: "videos",
        component: VideoIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/videos/:id",
        name: "video-show",
        component: VideoShow,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/calendar",
        name: "calendar",
        component: CalendarIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/documents",
        name: "documents",
        component: DocumentsIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/reports",
        name: "reports",
        component: ReportsIndex,
        meta: {
            guard: ["user"]
        }
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: { layout: "auth", guard: [] }
    },
    {
        path: "/settings",
        name: "settings",
        component: Settings,
        meta: {
            guard: ["user"]
        }
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    linkActiveClass: "bg-gray-700",
    routes
});

router.beforeEach((routeTo, routeFrom, next) => {
    let guards = routeTo.meta.guard;
    const tokenFromCookie = Cookies.get("token");
    let authType = store.getters["auth/user"]
        ? store.getters["auth/user"].type
        : null;

    if (!guards || guards.length < 1) {
    // public route
        next();
    } else if (!authType && !tokenFromCookie) {
    // no cookie + not log in
        next({ name: "login" });
    } else if (!authType && tokenFromCookie) {
    // try to log user with token store in cookie
        store.commit("auth/SET_TOKEN", tokenFromCookie);
        store.dispatch("auth/user").then(res => {
            if (parseInt(res.code) !== 200) {
                console.log("redirect to login");
                store.dispatch("auth/logout");
                Cookies.remove("token");
                next({ name: "login" });
            } else {
                authType = res.data.type;
                let nextVal = checkGuard(guards, authType);
                nextVal === true ? next() : next(nextVal);
            }
        });
    } else {
    // user already log
        let nextVal = checkGuard(guards, authType);
        nextVal === true ? next() : next(nextVal);
    }
});

export default router;
